export default {
  template: `
<div class="form-group" data-ng-if="$ctrl.show">
  <label class="col-md-2 control-label">{{$ctrl.label}}</label>
  <div class="col-md-3">
    <select class="input-sm form-control inline v-middle"
            data-ng-if="!$ctrl.select"
            data-ng-disabled="true"
            data-qa="{{$ctrl.label}}">
      <option value="">{{$ctrl.name}}</option>
    </select>
    <select class="input-sm form-control inline v-middle"
            data-ng-if="$ctrl.select"
            data-qa="{{$ctrl.label}}"
            data-ng-change="$ctrl.callback({newParentId: $ctrl.parentId})"
            data-ng-model="$ctrl.parentId"
            data-ng-selected="$ctrl.parentId"
            data-ng-options="eligibleParent.id as eligibleParent.name for eligibleParent in $ctrl.destination.eligibleParents | orderBy:'name'">
    </select>
  </div>
</div>
  `,
  bindings: {
    label: '@',
    name: '@',
    show: '<',
    select: '<',
    destination: '<',
    callback: '&',
  },
  controller: class {
    $onChanges(changes) {
      if (changes.destination && changes.destination.currentValue && changes.destination.currentValue.parentId) {
        this.parentId = changes.destination.currentValue.parentId;
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/destinations/general-configuration/destination-tree-select.component.js